import { __decorate } from "tslib";
import { id_netscapeCertExtension } from "./object_identifiers";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
export const id_netscapeSSLServerName = `${id_netscapeCertExtension}.12`;
let NetscapeSSLServerName = class NetscapeSSLServerName {
    constructor(value) {
        this.value = "";
        if (value) {
            this.value = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], NetscapeSSLServerName.prototype, "value", void 0);
NetscapeSSLServerName = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], NetscapeSSLServerName);
export { NetscapeSSLServerName };
